module.exports = __webpack_public_path__ + "img/no_notifications.0b7d4346.svg";